import { commercialReminderOverrideEvent } from "./commercialTracking.mjs";

// One explicit completion, not a toggle based on an old list snapshot.
// Do not report success from HTTP alone or from an optimistic checkbox.
export async function persistReminderCompletion(reminder, { request = fetch, doneAt = new Date().toISOString() } = {}) {
  if (!reminder?.id) throw new Error("Lembrete não encontrado.");
  if (reminder.source === "commercial_tracking" && reminder.type === "consultant_reply_required") {
    throw new Error("Responda ao cliente para concluir esta pendência.");
  }
  const commercial = reminder.source === "commercial_tracking";
  const command = commercial ? commercialReminderOverrideEvent(reminder, doneAt) : { status:"done", doneAt };
  // A new human click must not reuse a pre-fix processed/ineffective outbox
  // command. The App deduplicates concurrent clicks; keep this id per request.
  if (commercial) command.sourceId += `:${crypto?.randomUUID?.()
    || `${Date.now()}_${Math.random().toString(36).slice(2)}`}`;
  const response = await request(commercial ? "/api/commercial-events"
    : `/api/crm/reminders/${encodeURIComponent(reminder.id)}`, {
    method:commercial ? "POST" : "PATCH", credentials:"same-origin",
    headers:{ "Content-Type":"application/json", Accept:"application/json" },
    body:JSON.stringify(command),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok || payload?.ok !== true) {
    throw new Error(payload?.error || `Não foi possível concluir o lembrete (HTTP ${response.status}).`);
  }
  if (commercial) {
    const state = payload.result?.state;
    if (!state || state.nextActionAt || state.nextActionType) {
      throw new Error(payload.error || "O servidor não conseguiu gravar a conclusão. Tente novamente.");
    }
    return { reminder:{ ...reminder, status:"done", doneAt:state.updatedAt || doneAt }, commercialState:state };
  }
  if (String(payload.reminder?.id) !== String(reminder.id) || payload.reminder?.status !== "done"
    || !payload.reminder.doneAt) throw new Error("O servidor não confirmou a conclusão deste lembrete.");
  return { reminder:payload.reminder };
}

// A poll that started before the PATCH must not undo its confirmed completion.
// Apply only to the same owner/store; never carry a local state into a transfer.
export function reconcileReminderCompletions(reminders, confirmed) {
  return (reminders || []).filter(Boolean).map(reminder => {
    const saved = confirmed.get(String(reminder.id));
    return saved && String(saved.consultantId) === String(reminder.consultantId)
      && String(saved.storeId) === String(reminder.storeId)
      ? { ...reminder, status:saved.status, doneAt:saved.doneAt } : reminder;
  });
}
